<div class="badge-group-label">
  <span class="truncate badge-group-label__title">{{ label() }}</span>
  @if (singleSelect()) {
    <mp-filter-selection-info class="truncate" [label]="value()?.toString() ?? ''" />
  } @else {
    <mp-filter-badge [value]="value()" />
  }
</div>
